import React from 'react';
import { withStyles, SubAccountBalanceView } from 'vopay';
import BalanceDisplayCard from '../../BalanceDisplayCard';
import styles from '../OrgItem.module.scss';

const classes = withStyles(styles);

interface BalanceDisplayProps {
  currency: string;
  availableBalance: string;
  rollupAvailableBalance?: string;
  nodeId?: string;
  displayBalance: SubAccountBalanceView;
  selectedBalanceType: SubAccountBalanceView;
  onBalanceTypeChange?: (nodeId: string, balanceType: SubAccountBalanceView) => void;
}

const BalanceDisplay: React.FC<BalanceDisplayProps> = ({
  currency,
  availableBalance,
  rollupAvailableBalance,
  nodeId,
  displayBalance,
  selectedBalanceType,
  onBalanceTypeChange,
}) => {
  // Convert single currency balance to BalanceItem[] format
  const balanceItems = [
    {
      currency,
      availableBalance: availableBalance,
      rollupBalance: rollupAvailableBalance || '0',
    },
  ];

  // Handle balance type change
  const handleBalanceTypeChange = (balanceType: SubAccountBalanceView) => {
    if (nodeId && onBalanceTypeChange) {
      onBalanceTypeChange(nodeId, balanceType);
    }
  };

  return (
    <div className={classes('orgItemBottom')}>
      <BalanceDisplayCard
        balances={balanceItems}
        displayBalance={displayBalance}
        selectedBalanceType={selectedBalanceType}
        onBalanceTypeChange={handleBalanceTypeChange}
      />
    </div>
  );
};

export default BalanceDisplay;
